// @flow
import React from 'react';
import injectSheet from 'react-jss';
import cx from 'classnames';

class Select extends React.Component {
  props: {
    classes: $FlowIGNORE,
    className?: string,
    selected: string,
    options: string[],
    onSelect: (value: string) => void
  };

  static defaultProps = {
    bgColor: 'hsl(219, 15%, 20%)',
    color: 'hsl(160, 48%, 51%)',
    hoverColor: 'hsl(160, 48%, 90%)',
    hoverBackground: 'hsl(223,16%,32%)',
    selectedBackground: 'hsl(223, 14%, 23%)',
    fontSize: '15px'
  };

  state = {
    open: false
  };

  dropdownRef = React.createRef();

  handleClickRoot = (event: SyntheticEvent & { target: HTMLElement }) => {
    if (!(event.target instanceof HTMLElement)) return;
    if (!this.state.open) {
      this.setState({ open: true });
    } else {
      const didClickOption = this.dropdownRef.current.contains(event.target);

      if (!didClickOption) {
        this.setState({ open: !this.state.open });
      }
    }
  }

  handleClickOption = (event: MouseEvent & { currentTarget: EventTarget }) => {
    const option = event.currentTarget.getAttribute('value');

    event.stopPropagation();
    this.setState({ open: false });
    this.props.onSelect(option);
  }

  render() {
    const {
      classes: c, className, selected, options
    } = this.props;
    const value = options.find(o => o === selected);
    const Options = () => (
      <div
        className={cx(c.options, 'scrollbar')}
        ref={this.dropdownRef}
      >
        {options.map(option => (
          <div
            value={option}
            key={option}
            onClick={this.handleClickOption}
            className={cx(c.option, {
              'is-selected': option === selected
            })}
          >
            {option}
          </div>
        ))}
      </div>
    );

    return (
      <div
        className={cx(c.container, className)}
        onClick={this.handleClickRoot}
      >
        <div className={c.value}>
          {value}
        </div>
        <i className="material-icons">arrow_drop_down</i>
        {this.state.open && <Options />}
      </div>
    );
  }
}

export default injectSheet({
  container: {
    fontSize: ({ fontSize }) => fontSize,
    display: 'flex',
    alignItems: 'center',
    marginTop: '5px',
    borderRadius: '3px',
    position: 'relative',
    cursor: 'pointer',
    backgroundColor: ({ bgColor }) => bgColor,
    color: ({ color }) => color,
    '& > .material-icons': {
      position: 'absolute',
      right: '5px'
    }
  },
  value: {
    margin: '7px 15px'
  },
  options: {
    position: 'absolute',
    top: '100%',
    left: '0',
    right: '0',
    backgroundColor: ({ bgColor }) => bgColor,
    display: 'flex',
    flexDirection: 'column',
    maxHeight: '300px',
    overflowY: 'scroll'
  },
  option: {
    padding: '15px 15px',
    '&:hover': {
      color: ({ hoverColor }) => hoverColor,
      background: ({ hoverBackground }) => hoverBackground
    },
    '&.is-selected': {
      background: ({ selectedBackground }) => selectedBackground
    }
  }
})(Select);
